import React from 'react';
import { Camera, Mic } from 'lucide-react';
interface QuickShareProps {
  onShare: (type: string, value: string) => void;
}
const QuickShareBar = ({
  onShare
}: QuickShareProps) => {
  const quickEmojis = [{
    emoji: '❤️',
    label: "I'm thinking of you"
  }, {
    emoji: '👋',
    label: "Let's talk"
  }, {
    emoji: '🌟',
    label: 'Miss you'
  }, {
    emoji: '😊',
    label: 'Feeling happy'
  }, {
    emoji: '🤗',
    label: 'Big hug'
  }, {
    emoji: '☀️',
    label: 'Good day'
  }];
  return <div className="space-y-6" data-id="element-248">
      {/* Main Actions */}
      <div className="flex justify-center gap-4" data-id="element-249">
        <button onClick={() => onShare('voice', 'record')} className="flex-1 p-6 rounded-2xl bg-lavender/10 hover:bg-lavender/20 
            transition-all active:scale-95 flex flex-col items-center gap-2" aria-label="Send voice message" data-id="element-250">
          <Mic className="w-8 h-8 text-lavender mb-1" data-id="element-251" />
          <span className="text-lg" data-id="element-252">Voice</span>
        </button>
        <button onClick={() => onShare('photo', 'capture')} className="flex-1 p-6 rounded-2xl bg-soft-coral/10 hover:bg-soft-coral/20 
            transition-all active:scale-95 flex flex-col items-center gap-2" aria-label="Send photo" data-id="element-253">
          <Camera className="w-8 h-8 text-soft-coral mb-1" data-id="element-254" />
          <span className="text-lg" data-id="element-255">Photo</span>
        </button>
      </div>
      {/* Quick Emojis */}
      <div className="grid grid-cols-3 gap-3" data-id="element-256">
        {quickEmojis.map((item, index) => <button key={index} onClick={() => onShare('emotion', item.label)} className="p-4 rounded-2xl bg-white dark:bg-slate-700 shadow-sm 
              hover:scale-105 active:scale-95 transition-all" aria-label={item.label} data-id="element-257">
            <span className="text-3xl block mb-2" data-id="element-258">{item.emoji}</span>
            <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-259">
              {item.label}
            </span>
          </button>)}
      </div>
    </div>;
};
export default QuickShareBar;